import { render } from "./IconCog.vue?vue&type=template&id=1938009c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1938009c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1938009c', __exports__)) {
    api.reload('1938009c', __exports__)
  }
  
  module.hot.accept("./IconCog.vue?vue&type=template&id=1938009c", () => {
    api.rerender('1938009c', render)
  })

}


export default __exports__